/**
 * Endereços do painel de Tickets usados de fora dele (sino do header, aviso do
 * sistema operacional).
 */

/** Painel já com o filtro "Precisa de ação" ligado. */
export const NEEDS_ACTION_URL = '/tickets?needs_action=1';

/**
 * Parâmetro que abre um ticket no painel (detalhe na Lista, drawer no
 * Quadro). O painel lê e tira da URL, como o `?novo=1`.
 */
export const TICKET_PARAM = 'ticket';

/** O painel no filtro "Precisa de ação", com o ticket aberto. */
export const needsActionTicketUrl = (uid: string): string =>
  `${NEEDS_ACTION_URL}&${new URLSearchParams({
    [TICKET_PARAM]: uid,
  }).toString()}`;
